import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { jobGroupJobfeedAutoCompleteInput$, jobGroupJobfeedAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const JobGroupJobfeedAutoSuggest = renderAutoSuggestWithOptions(
   jobGroupJobfeedAutoCompleteObservable$,
   jobGroupJobfeedAutoCompleteInput$,
);

JobGroupJobfeedAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   filterOrganization: [],
   filterCompany: [],
   forceSelection: false,
   placeholder: 'Search JobGroup...',
};

export default JobGroupJobfeedAutoSuggest;
